module.exports = __webpack_public_path__ + "assets/img/420a65e8bb2d7864f4ece614ce170e7d.png";